<template>
  <div class="">
    <!-- grey opacity overlay -->
    <div class="flex justify-end fixed left-0 top-0 w-full h-full bg-grays-900/[0.43] z-[-1]"></div>
    <!-- transparent overlay -->
    <div class="fixed left-0 top-0 w-full h-full z-40"></div>
    <!-- step 1 -->
    <div v-if="step === 1"
         class="w-[513px] h-fit flex flex-row-reverse bg-white rounded absolute z-[51] right-[147px] top-[170px]">
      <!-- banner -->
      <div class="flex w-full h-full absolute top-0 left-0 rounded overflow-hidden z-0">
        <img alt="Logo Mishnat" class="w-full h-full object-cover" src="../../assets/images/onboarding/banner-1.png"/>
      </div>
      <!-- content -->
      <div class="flex flex-col flex-1 pt-[30px] pr-[26px] pb-[21px] gap-[47px] z-10">
        <div class="flex flex-col gap-[29px]">
          <h2 class="text-primary-700 text-2xl font-bold ">לוח מכירות</h2>
          <p class="text-grays-900 text-base font-regular max-w-[214px]">כאן תוכלו לראות ולהתעדכן בפרטים על המכירות
            הפעילות, המכירות הקרובות (בקרוב!) וההזמנות שעדיין לא אספתם.</p>
        </div>
        <div class="flex flex-row justify-between max-w-[214px] items-center">
          <p class="text-primary-700 text-base font-medium">
            <span class="font-bold">{{ step }}</span>/3
          </p>
          <div class="flex flex-row">
            <button-primary :small="true" @click="handleNextStep">
              להמשיך
            </button-primary>
          </div>
        </div>
      </div>
      <img alt="polygon green"
           class="absolute h-[36px] w-[20px] top-[11px] right-[-11px] m-auto"
           src="@/assets/icons/global/onboarding-polygon.svg"/>
    </div>
    <div v-if="step === 2"
         class="w-[530px] h-fit flex flex-row-reverse bg-white rounded absolute z-[45] top-[-482px] left-[-10px]">
      <!-- banner -->
      <div class="flex w-full h-full absolute top-0 left-0 rounded overflow-hidden z-0">
        <img alt="Logo Mishnat" class="w-full h-full object-cover" src="../../assets/images/onboarding/banner-2.png"/>
      </div>
      <!-- content -->
      <div class="flex flex-col flex-1 pt-[30px] pr-[26px] pb-[21px] gap-[47px] z-10">
        <div class="flex flex-col gap-[29px]">
          <h2 class="text-primary-700 text-2xl font-bold ">להוסיף לסל = הוזמן</h2>
          <p class="text-grays-900 text-base font-regular max-w-[210px]">
            במערכת שלנו אין קופה לתשלום סופי. ברגע שבחרתם מוצר והוספתם אותו לסל המשפחתי שלכם הוא שלכם.
          </p>
          <p class="text-grays-900 text-base font-regular max-w-[210px]">
            עד סגירת המערכת אתם יכולים עדיין להתלבט ולבחור לעדכן כמויות. כשהמערכת נסגרת - כל המוצרים שבסל, שלכם. ותחויבו
            עליהם באשראי בסמוך ליום האיסוף. </p>
        </div>
        <div class="flex flex-row items-center gap-[40px]">
          <p class="text-primary-700 text-base font-medium">
            <span class="font-bold">{{ step }}</span>/3
          </p>
          <div class="flex flex-row items-center">
            <button-text :small="true" @click="handlePrevStep">
              לחזור אחורה
            </button-text>
            <button-primary :small="true" @click="handleNextStep">
              להמשיך
            </button-primary>
          </div>
        </div>
      </div>
      <img alt="polygon green"
           class="absolute h-[36px] w-[20px] bottom-[-20px] left-[45px] m-auto rotate-90"
           src="@/assets/icons/global/onboarding-polygon.svg"/>
    </div>
    <div v-if="step === 3"
         class="w-[550px] h-fit flex flex-row-reverse bg-white rounded absolute z-[43] top-[310px] right-[150px]">
      <div class="flex w-full h-full absolute top-0 left-0 rounded overflow-hidden z-0">
        <img alt="Logo Mishnat" class="w-full h-full object-cover" src="../../assets/images/onboarding/banner-3.png"/>
      </div>
      <!-- content -->
      <div class="flex flex-col flex-1 pt-[30px] pr-[26px] pb-[21px] gap-[47px] z-10">
        <div class="flex flex-col gap-[29px]">
          <h2 class="text-primary-700 text-2xl font-bold ">תמיכה</h2>
          <p class="text-grays-900 text-base font-regular max-w-[214px]">
            איזה יופי שבאתם :) תוכלו לבדוק וללמוד כאן את כל הפיצ'רים המיוחדים במערכת שלנו.
          </p>
          <p class="text-grays-900 text-base font-regular max-w-[214px]">
            משהו בכל זאת לא מובן? תמיד אפשר לפנות לתמיכה שלנו.
          </p>
        </div>
        <div class="flex flex-row justify-between max-w-[240px] items-center">
          <p class="text-primary-700 text-base font-medium">
            <span class="font-bold">{{ step }}</span>/3
          </p>
          <div class="flex flex-row items-center">
            <button-text :small="true" @click="handlePrevStep">
              לחזור אחורה
            </button-text>
            <button-primary :small="true" @click="handleDone">
              סיימנו
            </button-primary>
          </div>
        </div>
      </div>
      <img alt="polygon green"
           class="absolute h-[36px] w-[20px] bottom-[60px] right-[-11px] m-auto"
           src="@/assets/icons/global/onboarding-polygon.svg"/>
    </div>
  </div>
</template>

<script>

import ButtonText from "@/components/Global/ButtonText.vue";
import ButtonPrimary from "@/components/Global/ButtonPrimary.vue";
import axiosInstance from "@/helpers/axios";
import ButtonCta from "@/components/Global/ButtonCTA.vue";

export default {
  name: "onboarding-modal",
  components: {ButtonCta, ButtonPrimary, ButtonText},
  props: {
    currentStep: Number,
    totalSteps: Number,
    targetSelector: String,
  },
  methods: {
    handleNextStep() {
      this.$store.dispatch("onboarding/handleStep", this.step + 1);
      this.scrollToModal();
    },
    handlePrevStep() {
      this.$store.dispatch("onboarding/handleStep", this.step - 1);
      this.scrollToModal();
    },
    async handleDone() {
      try {
        this.$store.dispatch("onboarding/toggleShow");
        localStorage.setItem("firstVisit", "false");
        const response = await axiosInstance.get("/profile/open_sales");
        if (response?.data?.data?.length) {
          const firstSale = response.data.data[0];
          if (!firstSale.order) {
            this.$store.commit("order/setSaleID", firstSale.id);
            this.$store.commit("order/setSale", firstSale);
            this.$store.commit(
              "order/setIsOnlyCard",
              !!firstSale.site?.card_only
            );
            this.$store.dispatch("order/toggleShowAgreement");

          } else {
            this.$router.push(`/order/${response.data.data[0].order.id}/${response.data.data[0].id}`).then(() => {
              window.location.reload();
            });
          }

        } else {
          this.$router.push("/");
        }
      } catch (e) {
        this.$router.push("/");
      }
    },
    scrollToModal() {
      this.$nextTick(() => {
        const modalElements = this.$el.querySelectorAll('.z-\\[42\\], .z-\\[43\\], .z-\\[45\\]');
        const modalElement = Array.from(modalElements).find(modal => modal.offsetParent !== null);

        if (modalElement) {
          if (this.step === 2) {
            const rect = modalElement.getBoundingClientRect();
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const modalTop = rect.top + scrollTop - (window.innerHeight / 2) + (rect.height / 2);

            window.scrollTo({
              top: modalTop,
              behavior: 'smooth'
            });
          } else if (this.step === 3) {
            const sidebar = document.querySelector('.sidebar');
            if (sidebar && sidebar.scrollHeight > sidebar.clientHeight) {
              sidebar.scrollTo({
                top: sidebar.scrollHeight,
                behavior: 'smooth'
              });
            }
          }
        }
      });
    },

  },

  computed: {
    step() {
      return this.$store.state.onboarding.step
    },
    show() {
      return this.$store.state.onboarding.show
    },
  },
  watch: {
    show() {
      if (!this.show) {
        document.body.classList.remove("body-scroll-hidden");
      }
    },
    step() {
      this.scrollToModal();
    },
  },
  mounted() {
    if (this.show) {
      document.body.classList.add("body-scroll-hidden");
    }
    this.scrollToModal();
  }
}
</script>

<style>

</style>